/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from "clsx";


type TabType = {
  name: string;
  value: string;
}

interface Props {
  activeTab: string;
  setTab: any;
  space?: string;
  tabs: TabType[];
}

const Tabs = ({ activeTab, setTab, space, tabs }: Props) => {
  // eslint-disable-next-line no-unused-vars
  //   const [isPending, startTransition] = useTransition();

  return (
    <div>
      {/* <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          value={activeTab}
          onChange={(e) => setTab(e.target.value)}
          id="tabs"
          name="tabs"
          className="block w-full pl-3 pr-10 py-2 text-base bg-white border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
        >
          {tabs.map((tab, index) => (
            <option key={index} value={tab.value}>
              {tab.name}
            </option>
          ))}
        </select>
      </div> */}
      <div >
        {/* <div className=" "> */}
        <nav
          className={`${space ? `space-x-${space}` : "space-x-8"
            } -mb-px flex border-b border-gray-200 dark:border-grey-600`}
          aria-label="Tabs"
        >
          {tabs.map((tab, index) => (
            <span
              key={index}
              //
              onClick={() => setTab(tab.value)}
              className={clsx(
                tab.value === activeTab
                  ? "border-black text-black dark:text-indigo-200 dark:border-indigo-200 whitespace-nowrap cursor-pointer flex py-4 px-1 border-b-2 font-medium text-sm"
                  : "border-transparent text-gray-400 hover:text-gray-700  hover:border-gray-200 whitespace-nowrap cursor-pointer flex py-4 px-1 border-b-2 font-medium text-sm"
              )}
            >
              {tab.name}
            </span>
          ))}
        </nav>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Tabs;
